<template>
    <section id="elle-related-posts" class="elle-related-posts padd-v bg-light01">
        <div class="container">
            <UiHeadline
                :settings="{
                    label: $t('news.label'),
                    headline: `${$t('news.headline_1')}<br>${$t('news.headline_2')}`
                }"
            />

            <LoopsPosts v-if="isDesktop" :posts="relatedPosts" />
            <UiSliderMobile v-else class="padd-v-top">
                <template #sliders>
                    <swiper-slide v-for="item in relatedPosts" :key="item.id" class="swiper-slide">
                        <CardsPost :post="item" />
                    </swiper-slide>
                </template>
            </UiSliderMobile>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        relatedPosts?: CmsItem[];
    }>(),
    {
        relatedPosts: () => []
    }
);

const relatedPosts = computed(() => props.relatedPosts);

const isDesktop = useMediaQuery('(min-width: 768px)');
</script>
